import i18n from '@signavio/i18n';
import { DangerDialog, Dialog } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
function Confirm({
  children,
  danger,
  disabled,
  cancelLabel,
  confirmLabel,
  title,
  icon,
  open,
  onCancel,
  onConfirm,
  className
}) {
  if (danger) {
    return /*#__PURE__*/_jsx(DangerDialog, {
      open: open,
      title: title,
      disableConfirm: disabled,
      confirmLabel: confirmLabel || i18n('Ok'),
      cancelLabel: cancelLabel || i18n('Cancel'),
      onCancel: onCancel,
      onConfirm: onConfirm,
      className: className,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Dialog, {
    icon: icon,
    open: open,
    title: title,
    disableConfirm: disabled,
    confirmLabel: confirmLabel || i18n('Ok'),
    cancelLabel: cancelLabel || i18n('Cancel'),
    onCancel: onCancel,
    onConfirm: onConfirm,
    className: className,
    children: children
  });
}
export default Confirm;